import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedProductsInput,
    PrintedProducts,
    UpdatePrintedProductsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedProductsService {
    private amplifyClient = generateClient();

    constructor() {}

    async getPrintedProducts(id: string): Promise<PrintedProducts | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPrintedProducts,
                    variables: { id }
                })
            ).data.getPrintedProducts;
            return data ? (data as PrintedProducts) : null;
        } catch (error) {
            console.error('Error finding PrintedProducts:', error);
            return null;
        }
    }

    async listPrintedProducts(): Promise<PrintedProducts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedProducts
                })
            ).data.listPrintedProducts.items;
            if (data) return data as PrintedProducts[];
        } catch (error) {
            console.error('Error finding PrintedProducts:', error);
            return null;
        }
    }

    async printedProductsBySubcategoryPosition(
        PrintedSubcategoryId: string
    ): Promise<PrintedProducts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PrintedProductsBySubcategoryPosition,
                    variables: {
                        PrintedSubcategoryId
                    }
                })
            ).data.PrintedProductsBySubcategoryPosition.items;
            if (data) return data as PrintedProducts[];
        } catch (error) {
            console.error('Error finding PrintedProducts:', error);
            return null;
        }
    }

    async printedProductsBySubcategoryCreated(
        PrintedSubcategoryId: string
    ): Promise<PrintedProducts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PrintedProductsBySubcategoryCreated,
                    variables: {
                        PrintedSubcategoryId
                    }
                })
            ).data.PrintedProductsBySubcategoryCreated.items;
            if (data) return data as PrintedProducts[];
        } catch (error) {
            console.error('Error finding PrintedProducts:', error);
            return null;
        }
    }

    async printedProductsByCategoryPosition(
        printedCategoryId: string
    ): Promise<PrintedProducts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PrintedProductsByCategoryPosition,
                    variables: {
                        printedCategoryId
                    }
                })
            ).data.PrintedProductsByCategoryPosition.items;
            if (data) return data as PrintedProducts[];
        } catch (error) {
            console.error('Error finding PrintedProducts:', error);
            return null;
        }
    }
    async printedProductsByCategoryCreated(
        printedCategoryId: string
    ): Promise<PrintedProducts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PrintedProductsByCategoryCreated,
                    variables: {
                        printedCategoryId
                    }
                })
            ).data.PrintedProductsByCategoryCreated.items;
            if (data) return data as PrintedProducts[];
        } catch (error) {
            console.error('Error finding PrintedProducts:', error);
            return null;
        }
    }

    async createPrintedProducts(
        input: CreatePrintedProductsInput
    ): Promise<PrintedProducts> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedProducts,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedProducts;
            if (data) return data as PrintedProducts;
        } catch (error) {
            console.error('Error creating PrintedProducts:', error);
            return null;
        }
    }
    async updatePrintedProducts(
        input: UpdatePrintedProductsInput
    ): Promise<PrintedProducts> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedProducts,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedProducts;
            if (data) return data as PrintedProducts;
        } catch (error) {
            console.error('Error creating PrintedProducts:', error);
            return null;
        }
    }
}
